import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {PiecesPotsListPage} from './pages/PiecesPotsListPage'

const PiecesPotsWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[
        {title: 'Gestion des Pièces POT', path: '#', isSeparator: false, isActive: true}
      ]}>Liste</PageTitle>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PiecesPotsListPage />
            </>
          }
        />

        <Route index element={<Navigate to='/pieces-pots/liste' />} />
      </Routes>
    </>
  )
}

export {PiecesPotsWrapper}
